export const props = { viewBox: "0 0 24 24" };
export const innerHTML = '<rect width="24" height="24" fill="#F7B500"/>';
